import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'resultsAreFromApps'
	| 'connectPromptIntro'
	| 'connectAppName'
	| 'connect'
	| 'connected'
	| 'dismissBannerLabel';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description: string }
> = defineMessages({
	resultsAreFromApps: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.results-are-from-apps',
		defaultMessage: 'Results are from {appList}.',
		description: 'Banner message indicating which apps the results are from',
	},
	connectPromptIntro: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connect-prompt-intro',
		defaultMessage:
			'Connect {appList} below and real context will start flowing into drafts like this, usually within a few hours. Need something specific now? Paste a link and I’ll use it right away.',
		description:
			'Invitational banner message for the 3P suggested-prompts variant, prompting the user to connect the listed apps',
	},
	connectAppName: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connect-app-name',
		defaultMessage: 'Connect {appName}',
		description: 'Button text to connect to a specific app',
	},
	connect: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connect',
		defaultMessage: 'Connect',
		description:
			'Short button text to connect a connector whose name is already shown beside the button (3P suggested-prompts row layout)',
	},
	connected: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connected',
		defaultMessage: 'Connected',
		description:
			'Non-interactive label shown on a connector row after the user successfully connects it, replacing the Connect button',
	},
	dismissBannerLabel: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.dismiss-label',
		defaultMessage: 'Dismiss app connection banner',
		description: 'Accessible label for the button to dismiss the app connection banner',
	},
});
